import React, { useEffect, useState, useMemo } from "react";
import { getParameterByName, findObjectDifferences } from "../../../utils";
import moment from 'moment';
import { connect, useSelector } from 'react-redux';
import { getSiteGroups, getAllSites } from "../../../../actions/site_actions";
import { Map, List, OrderedSet, fromJS } from "immutable";
import { browserHistory } from "react-router";
import { verifyMSPASinatoryId } from "../../../../api/usnat/vendor_list";
import {
  getUSPrivacyRegulation,
  updateRegulation,
  getSystemPurposes,
  getAccountList,
  getSystemStacks,
  clearRegulationError,
  getGlobalVendors,
  getStateSupportRegions
} from "../../../../actions/us_privacy_regulation_actions";
import { useActions } from "../../../../hooks";
import { USPrivacyRegulation } from "../../../../records/us_privacy_regulation_records";
import {   message } from "../../../../styleguide";
import {
  AdvancedSettings,
  OptInAndOptOut,
  IndustryFramework,
  LanguageTranslations,
  NameAndProperty,
  SelectPurposes,
  VendorManagement,
  ChoiceSelection,
  RegionMapping
} from "../NewPrivacyRegulation/Steps";
import { evaluateRequriedFieldsFromStep, stepsData,steps_data_global_standard, steps_data_state_specific, updateCategoryCache, renderInfoTip, renderTranslationWarningError, validateTranslation, valideAllStepsBeforeSave, updateStatusForAllSteps, IAB_CHOICES_SYSTEM_IDS, categorySortFunc, getSelectedCodesBasedOnAppliesGeos } from "../helper";
import Loading from "../../../common/Loading.js";
import DismissErrorModal from "../../../common/DismissErrorModal";
import { InfoCircleFilled } from "@ant-design/icons";
import { updateStepsDataFunction, getStepsDataFieldMap, getOrderedStepsKeys } from "../../../common/SequentialNavigationWizard/SequentialLeftNav.jsx";
import { handleServerSideErrors, renderCannotUpdateRegulationError } from "../../vendor_list_v2/helper";
import { usPrivacyRegulationContext } from "../contexts";
import { Button, Alert, Tabs, Modal, Typography } from "antd";
import { flattenCategories } from "../../vendor_list_v2/edit/wizard/helper.js";
import RegionMappingGlobalStandard from "../global_standard/RegionMappingGlobalStandard.jsx";
import { GEO_LIST_TREE_STRUCTURE } from "../../../../constants.js";

const TabPane = Tabs.TabPane;

const USPrivacyRegulationEdit = (props) => {
  const isGlobalStandardFlow = props.route.globalStandard;

  const [usPrivacyRegulation, setUSPrivacyRegulation] = useState(null);
  const [intermediateUSPRegulation, setIntermediateUSPRegulation] = useState(null);
  const [stepsDataForEditFlow, setStepsDataForEditFlow] = useState(List([]));
  const [current, setCurrent] = useState("name_property_selection");
  const [currentRelay, setCurrentRelay] = useState(null);
  const [exitEditModal, setExitEditModal] = useState(false)
  const [showTranslationModal, setShowTranslationModal] = useState(false)
  const [translationErrorContent, setTranslationErrorContent] = useState(null);
  const [previousLegislation, setPreviousLegisation] = useState(null);
  //for vendors context
  const [vendorsIdsMap, setVendorIdsMap] = useState(props.globalVendors?.reduce((map, item) => {
    map[item.id] = item.ids;
    return map;
  }));
  useEffect(()=>{
    if(props.globalVendors.size){
      setVendorIdsMap(props.globalVendors.reduce((map, item) => {
        map[item.id] = item.ids;
        return map;
      }, {}))
    }
  },[props.globalVendors])

  //server side error
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [serverErrors, setServerErrors] = useState();

  //global categories cache
  const [regulationCategoryOptionsCache, setRegulationCategoryOptionsCache] = useState(null)

  // to persist custom choice selection options throughout wizard flow
  const [customPrivacyChoiceOptions, setCustomPrivacyChoiceOptions] = useState([]);

  const regulationId = getParameterByName("regulationId");

  //actions and redux state
  const accountsList = useSelector(state => state.usPrivacyReducerState.getIn(['vendorList', 'value']));
  const regulationsList = accountsList?.filter(regulation => regulation.name !== usPrivacyRegulation?.name);
  const systemPurposes = useSelector(state => state.usPrivacyReducerState.getIn(['purposes', 'value']))
    ?.map((cat) => {
      let updatedCat = cat;      
      if(Object.values(IAB_CHOICES_SYSTEM_IDS).includes(cat.systemId)) {
        updatedCat = cat.set("isNegative", true);
      }
      return updatedCat;
    })
    ?.sort(categorySortFunc);

  const systemStacks = useSelector(state => state.usPrivacyReducerState.getIn(['stacks', 'value']));
  const regulationListsErrorState = useSelector(state => state.usPrivacyReducerState.getIn(['vendorList', 'error']));
  const regulationSavePending = useSelector(state => state.usPrivacyReducerState.get('savePending'));
  const clearRegulationErrorAction = useActions(clearRegulationError);
  const getUsPrivacyRegulationAction = useActions(getUSPrivacyRegulation);
  const getPurposes = useActions(getSystemPurposes);
  const getStacks = useActions(getSystemStacks);
  const getStateStringRegions = useActions(getStateSupportRegions);
  const updateRegulationAction = useActions(updateRegulation);
  const getUSPrivacyAccountsList = useActions(getAccountList);

  const stepsKeyNameMap = getStepsDataFieldMap(stepsDataForEditFlow, 'title')
  const stepsErrorMap = getStepsDataFieldMap(stepsDataForEditFlow, 'error')
  const stepsWarningMap = getStepsDataFieldMap(stepsDataForEditFlow, 'warning');

  const [modal, contextHolder] = Modal.useModal();

  // delete stepsKeyNameMap['summary'];
  const indexSiteNameMap = useMemo(() => props.sites.toJS().reduce((map, obj) => (map[obj.id] = obj.domain, map), {}), [props.sites]);

  //server side error
  useEffect(() => {
    if(regulationListsErrorState){
      const serverErrors = handleServerSideErrors(regulationListsErrorState, indexSiteNameMap);
      if(serverErrors){
        setShowErrorModal(true)
        setServerErrors(serverErrors)
      } else {
        message.error("Something went wrong")
      }
    }
    return () => {
      clearRegulationErrorAction(isGlobalStandardFlow);
    }
  },[regulationListsErrorState]);

  useEffect(() => {
    // (async () => {
    //   const systemPurposes = await getPurposes();
    //   getStacks(systemPurposes);
    // })();
    props.getSiteGroups(props.currentUser);
    props.getAllSites();
    props.getGlobalVendors(isGlobalStandardFlow);
    getUSPrivacyAccountsList(isGlobalStandardFlow);
  }, [isGlobalStandardFlow]);

  useEffect(()=>{
    let categoriesCache = List([])
    if(intermediateUSPRegulation){
      // if(intermediateUSPRegulation.legislation === "hybrid") {
      //   const onlyPurposesNotInStack = systemPurposes.filter( purpose => !systemStacks.some( stack => stack.categories.map( c => c.purposeRef.id).includes(purpose.purposeRef.id)))
      
      //   onlyPurposesNotInStack.forEach((purpose) => {
      //     categoriesCache = categoriesCache.push(purpose);
      //   });
      //   systemStacks.forEach((stack)=>{
      //     categoriesCache = categoriesCache.push(stack);
  
      //   })
      // } else {
        categoriesCache = systemPurposes;
      // }
      categoriesCache = updateCategoryCache(categoriesCache, intermediateUSPRegulation, true)

      setRegulationCategoryOptionsCache(categoriesCache)
    }
  },[systemStacks, intermediateUSPRegulation])

  useEffect(() => {
    (async () => {
      if (props.currentUser.accountId) {
        let usPrivacyRegulation = await getUsPrivacyRegulationAction(isGlobalStandardFlow, regulationId, props.currentUser.accountId);
        if(usPrivacyRegulation.get('signatoryId')) {
          try {
            const signatory = await verifyMSPASinatoryId(isGlobalStandardFlow, usPrivacyRegulation.signatoryId);
            if(signatory.id){
              usPrivacyRegulation = usPrivacyRegulation.set('signatoryName', signatory.name);
            }

          }catch (err) {
            if(err) {
              message.error(<>Identification ID {usPrivacyRegulation.get('signatoryId')} is Invalid.</>)
              // usPrivacyRegulation = usPrivacyRegulation.set('signatoryId', signatory.name);
            }
          }
        }
        // filter systemIds 1 and 2 if state workflow DIA-4646
        getStateStringRegions(isGlobalStandardFlow);
        const systemPurposes = await getPurposes(isGlobalStandardFlow, null);
        getStacks(isGlobalStandardFlow ,systemPurposes);
        usPrivacyRegulation = usPrivacyRegulation.update("categories", (categories) => flattenCategories(categories));

        //DIA-5985 need to rebuild enumerated States because logic within the USNAT flow is based on that
        usPrivacyRegulation = usPrivacyRegulation.update("configByGeo", (configByGeo) => {
          const updatedConfigByGeo = {};
          GEO_LIST_TREE_STRUCTURE.forEach((geo) => {
            if (geo.code === "US" && configByGeo["US"]?.legislation === "usnat") {
              geo.children.forEach((state) => {
                updatedConfigByGeo[state.code.replace("STATE_", "US_")] = { legislation: "usnat" };
              });
            } else if (geo.code === "CA" && configByGeo["CA"]?.legislation === "usnat") {
              geo.children.forEach((province) => {
                updatedConfigByGeo[province.code] = { legislation: "usnat" };
              });
            }
          });
          // Copy all other entries from configByGeo that are not "US" or "CA"
          Object.entries(configByGeo).forEach(([key, value]) => {
            if (!((key === "US" && value.legislation === "usnat") || (key === "CA" && value.legislation === "usnat"))) {
              updatedConfigByGeo[key] = value;
            }
          });
          const selectedCodes = getSelectedCodesBasedOnAppliesGeos(usPrivacyRegulation.get("appliesGeos"), usPrivacyRegulation.get("exclusionGeos"), GEO_LIST_TREE_STRUCTURE);
          let usPrefixSelectedCodes = selectedCodes.map(c => c.replace("STATE_", "US_"));
          const updatedConfigByGeoForVL = Object.fromEntries(
            Object.entries(updatedConfigByGeo).filter(([key]) => usPrefixSelectedCodes.includes(key))
          );
          return updatedConfigByGeoForVL;
        })
        setUSPrivacyRegulation(usPrivacyRegulation);
        setIntermediateUSPRegulation(usPrivacyRegulation?.toJS());
        if(usPrivacyRegulation?.get("deletedVendors")?.size){
          setStepsDataForEditFlow(updateStepsDataFunction(stepsDataForEditFlow, "vendor_management", 'warning', true));
        }
        let steps = stepsData;
        // if(usPrivacyRegulation.legislation === "state") {
        steps = isGlobalStandardFlow ? steps_data_global_standard : steps_data_state_specific;
        // }
        setStepsDataForEditFlow(fromJS(updateStatusForAllSteps(steps, "finish")))
      }
    })();
  }, [props.currentUser]);

  useEffect(() => {
    if(usPrivacyRegulation) {
      const previousLegislation = accountsList.find((vl) => vl.id === usPrivacyRegulation.id)?.legislation;
      setPreviousLegisation(previousLegislation);
    }
  },[accountsList, usPrivacyRegulation]);

  useEffect( () => {
     if(previousLegislation && previousLegislation === "usnat" && intermediateUSPRegulation.legislation === "hybrid") {
        modal.confirm({
          title: "Vendor List Migration",
          content: <Typography.Text><br/>Your vendor list settings have been transitioned with no changes.<br/><br/>With our updated US Global Privacy Protocol solution, you can now choose which section of the IAB's GPP framework to apply on a state by state basis. You can select either the "US National" string or individual "US State" strings where available.<br/><br/>Before saving your vendor list for the first time, please review your vendor list settings, ensure you're comfortable with your selections and confirm that your third-party vendors support them. You can find IAB's documentation <a href="https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/Section%20Information.md#section-ids" target="_blank">here</a>.<br/><br/>If you have any questions or need further clarification, please don't hesitate to contact us at <a href="mailto:support@sourcepoint.com">support@sourcepoint.com</a>.</Typography.Text>,
          width: 700,
          cancelButtonProps: {style: {display: "none"}}
        })
      }
  },[previousLegislation])

  const shouldStopFlowForTranslationError = () =>{
    const translationError = validateTranslation(intermediateUSPRegulation)
    if(translationError) {
      setTranslationErrorContent(translationError)
      setShowTranslationModal(true)
      return true;
    }
    return false
  }

  const handleSaveRegulation = async () => {  
    let confirmation = true;
    if(previousLegislation === "usnat" && usPrivacyRegulation?.legislation === "hybrid") {
      confirmation = await modal.confirm({
        title: "Acknowledgment",
        content: `Once you save the vendor list for the first time, all changes will become effective.`,
        width: 700,
      })
    }
    if(!confirmation) {
      return;
    }

    const stepsWithError = valideAllStepsBeforeSave(getOrderedStepsKeys(stepsDataForEditFlow), intermediateUSPRegulation, regulationsList, true)
    
    if(stepsWithError.length == 0) {
      try {
        let resp = await updateRegulationAction(isGlobalStandardFlow, props.currentUser.accountId, new USPrivacyRegulation(intermediateUSPRegulation));
        if(resp?.name) {
          message.success(<>  Regulation <b>{resp.name}</b> has been updated</>);
          setUSPrivacyRegulation(resp);
          setIntermediateUSPRegulation(resp?.toJS());
          if(resp?.get("deletedVendors")?.size){
            setStepsDataForEditFlow(updateStepsDataFunction(stepsDataForEditFlow, "vendor_management", 'warning', true));
          }
          setCustomPrivacyChoiceOptions([])
        }
      }catch (error) {
        message.error("Regulation could not be saved");
      }
    } else {
      setCurrent(stepsWithError[0]);
      stepsWithError.forEach(step => updateShowError(step, true))
    }
  };

  const handleExitEditRegulation = () => {
    const isUnsavedChangesPresent = findObjectDifferences(usPrivacyRegulation?.toJS(), intermediateUSPRegulation)
    if (!_.isEmpty(isUnsavedChangesPresent)) {
      setExitEditModal(true);
    } else {
      browserHistory.push(isGlobalStandardFlow ? "/global_enterprise" : "/us_privacy/regulations");
    }
  }

  const onChange = (value, skipTranslationErrorCheck = true) => {
    if (evaluateRequriedFieldsFromStep(current, intermediateUSPRegulation, regulationsList)) {
      updateShowError(current, false);
      if (skipTranslationErrorCheck && (current === 'language_translations' && shouldStopFlowForTranslationError())) {
        setCurrentRelay(value);
        return;
      }
      if(current == 'language_translations' || current == 'opt_in_opt_out' || current == 'vendor_management' || current == "region_mapping") {
        setRegulationCategoryOptionsCache(updateCategoryCache(regulationCategoryOptionsCache, intermediateUSPRegulation, false));
        setStepsDataForEditFlow(updateStepsDataFunction(stepsDataForEditFlow, current, 'warning', false));
      }
      setCurrent(value);
    } else {
      updateShowError(current, true);
    }
  };

  const updateShowError = (step, isIncomplete) => {
    setStepsDataForEditFlow(updateStepsDataFunction(stepsDataForEditFlow, step, 'error', isIncomplete));
  };

  const resetValidationError = (step) => {
    if(evaluateRequriedFieldsFromStep(step, intermediateUSPRegulation, regulationsList)){
      updateShowError(step, false)
    }
  }

  const changesDetectedAlert = (
    <Alert showIcon style={{marginBottom: 16}} icon={<InfoCircleFilled className="info-icon" />} message={<div>Updates made in the <b>Choice Selection</b> step have resulted in new modifications in the current step. <b>Please review the recent updates before proceeding.</b></div>} type="warning"/>
  )

  let readOnly = false;
  if(!props.currentUser?.allFeatureAccess) {
    let comparaterString = isGlobalStandardFlow ? 'Vendor List - Global Enterprise' : 'Vendor List - U.S. Multi-State';
    if(props.currentUser?.featureAccess && !props.currentUser?.featureAccess.includes(comparaterString)) {
      readOnly = true;
    }
  }

  const renderWizardStepComponent = (key) => {
    let component;
    switch (key) {
      case "name_property_selection":
        component = (
          <NameAndProperty
            usPrivacyRegulation={intermediateUSPRegulation}
            showError={stepsErrorMap.get("name_property_selection")}
            resetValidationError={() => resetValidationError("name_property_selection")}
            sites={props.sites}
            siteGroups={props.siteGroups}
            currentUser={props.currentUser}
            regulationsList={regulationsList}
            isEditFlow={true}
            readOnly={readOnly}
            isGlobalStandardFlow={isGlobalStandardFlow}
          />
        );
        break;
      case "industry_framework":
        component = (
          <IndustryFramework
            usPrivacyRegulation={intermediateUSPRegulation}
            showError={stepsErrorMap.get("industry_framework")}
            resetValidationError={() => resetValidationError("industry_framework")}
            readOnly={readOnly}
            onlyUsStates={intermediateUSPRegulation.legislation === "state" }
            isNoFrameworkFlow={intermediateUSPRegulation.legislation === "state" && intermediateUSPRegulation.nonIab}
            isHybrid={intermediateUSPRegulation.legislation == "hybrid"}
          />
        );
        break;
      case "select_puropses":
        component = (
          <SelectPurposes
            usPrivacyRegulation={intermediateUSPRegulation}
            showError={stepsErrorMap.get("select_puropses")}
            resetValidationError={() => resetValidationError("select_puropses")}
            goToSignatoryIdStep={() => onChange("industry_framework")}
            regulationCategoryOptionsCache={regulationCategoryOptionsCache}
            stepsData={stepsDataForEditFlow}
            setStepsData={setStepsDataForEditFlow}
            current={current}
            readOnly={readOnly}
            isHybrid={intermediateUSPRegulation.legislation == "hybrid"}
          />
        );
        break;
      case "language_translations":
        component = (
          <LanguageTranslations
            usPrivacyRegulation={intermediateUSPRegulation}
            changesDetectedWarning={stepsWarningMap.get("language_translations") ? changesDetectedAlert : null}
            showError={stepsErrorMap.get("language_translations")}
            readOnly={readOnly}
            resetValidationError={() => resetValidationError("language_translations")}
            showMessageSentiment={(intermediateUSPRegulation.legislation !== "state" || !intermediateUSPRegulation.nonIab) || isGlobalStandardFlow}
          />
        );
        break;
      case "vendor_management":
        component = (
          <VendorManagement
            usPrivacyRegulation={intermediateUSPRegulation}
            changesDetectedWarning={stepsWarningMap.get("vendor_management") ? changesDetectedAlert : null}
            readOnly={readOnly}
            isGlobalStandardFlow={isGlobalStandardFlow}
          />
        );
        break;
      case "opt_in_opt_out":
        component = (
          <OptInAndOptOut
            usPrivacyRegulation={intermediateUSPRegulation}
            changesDetectedWarning={stepsWarningMap.get("opt_in_opt_out") ? changesDetectedAlert : null}
            readOnly={readOnly}
            isGlobalStandardFlow={isGlobalStandardFlow}
          />
        );
        break;
      case "signal_settings":
        component = (
          <AdvancedSettings
            usPrivacyRegulation={intermediateUSPRegulation}
            readOnly={readOnly}
            showError={stepsErrorMap.get("signal_settings")}
            resetValidationError={() => resetValidationError("signal_settings")}
          />
        );
        break;
      case "choice_selection":
        component = (
          <ChoiceSelection
            usPrivacyRegulation={intermediateUSPRegulation}
            showError={stepsErrorMap.get("choice_selection")}
            resetValidationError={() => resetValidationError("choice_selection")}
            regulationCategoryOptionsCache={regulationCategoryOptionsCache}
            stepsData={stepsDataForEditFlow}
            setStepsData={setStepsDataForEditFlow}
            current={current}
            readOnly={readOnly}
            isNoFrameworkFlow={intermediateUSPRegulation.legislation === "state" && intermediateUSPRegulation.nonIab}
            isGlobalStandardFlow={isGlobalStandardFlow}
            setCustomPrivacyChoiceOptions={setCustomPrivacyChoiceOptions}
            customPrivacyChoiceOptions={customPrivacyChoiceOptions}
          />
        )
        break;
      case "region_mapping":
        component = isGlobalStandardFlow ? (
          <RegionMappingGlobalStandard
            usPrivacyRegulation={intermediateUSPRegulation}
            changesDetectedWarning={stepsWarningMap.get("region_mapping") ? changesDetectedAlert : null}
            showError={stepsErrorMap.get("region_mapping")}
            resetValidationError={() => resetValidationError("region_mapping")}
          />
        ) : (
          <RegionMapping
            usPrivacyRegulation={intermediateUSPRegulation}
            isNoFrameworkFlow={intermediateUSPRegulation.legislation === "state" && intermediateUSPRegulation.nonIab}
            changesDetectedWarning={stepsWarningMap.get("region_mapping") ? changesDetectedAlert : null}
            previousLegislation={previousLegislation}
          />
        )
        break;
    }
    return regulationSavePending ? <Loading/> : component;
  };

  const steps = intermediateUSPRegulation
    ? getOrderedStepsKeys(stepsDataForEditFlow).filter(key => key !== 'summary').map((key) => {
      let warningIcon = stepsWarningMap.get(key) ? renderInfoTip("Changes Detected", "warning") : null;
      warningIcon = stepsErrorMap.get(key) ? renderInfoTip("Error(s) found", "error-icon") :  warningIcon;
      return (
        <TabPane
          className="edit-us-privacy-component"
          tab={<>{stepsKeyNameMap.get(key)}{warningIcon}</>}
          key={key}
        >
          {renderWizardStepComponent(key)}
        </TabPane>
      )})
    : null;

  const handleResumeWizardFlow = (e) => {
    e.preventDefault();
    setShowTranslationModal(false);
    onChange(currentRelay, false)
  }

  const failedToUpdateRegulationError = renderCannotUpdateRegulationError(intermediateUSPRegulation, serverErrors);

  return !intermediateUSPRegulation ? (
    <Loading />
  ) : (
    <>
    <div className="us-privacy-regulation-edit">
      <div className="back-link pointer" onClick={handleExitEditRegulation}>
        {`< Back`}
      </div>
      <div className="header">
        <div>
          <b>{intermediateUSPRegulation?.name}</b> - { isGlobalStandardFlow ? "Global Enterprise" : intermediateUSPRegulation.nonIab ? "Standard" : "IAB Global Privacy Protocol"} Regulation
        </div>
        <div>
          <Button type="link" onClick={handleExitEditRegulation}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSaveRegulation} disabled={readOnly}>
            Save
          </Button>
        </div>
      </div>
      <usPrivacyRegulationContext.Provider value={{vendorsIdsMap, isGlobalStandardFlow}}>
      <Tabs
        defaultActiveKey="name_property_selection"
        activeKey={current}
        onChange={onChange}
        destroyInactiveTabPane={true}
      >
        {steps}
      </Tabs>
      </usPrivacyRegulationContext.Provider>
    </div>
    { props.pendingRequestsMap.get('regulation') ? <Loading/> : null }
    { exitEditModal ? 
      <DismissErrorModal
        modalWrapperClass="operation-confirmation"
        title={"Unsaved Changes"}
        error={<><div>There are <b>unsaved changes</b>. If you leave this page, you will lose all the changes you have made.</div> <br/><div>Are you sure you wish to leave the page?</div></>}
        isModalVisible={exitEditModal}
        handleCancel={()=>{browserHistory.push(isGlobalStandardFlow ? "/global_enterprise" : "/us_privacy/regulations"); setExitEditModal(false)}}
        renderOk
        okText={"Keep Editing"}
        cancelText={"Leave without saving"}
        handleOk={()=>{setExitEditModal(false)}}
        primaryAction="submit"
        dontShowCross={true}
      /> : null}
    { showErrorModal && (<DismissErrorModal
      modalWrapperClass="activate-confirmation"
      title={"Activate Regulation"}
      error={failedToUpdateRegulationError}
      isModalVisible={showErrorModal}
      handleCancel={() => setShowErrorModal(false)}
      renderOk={false}
      okText={"OK"}
      cancelText={"Close"}
      handleOk={() => setShowErrorModal(false)}
      primaryAction="submit"
    />)}
    { showTranslationModal ?
      <DismissErrorModal
        title={"Missing Translations"}
        modalWrapperClass="activate-confirmation"
        error={renderTranslationWarningError(translationErrorContent)}
        isModalVisible={showTranslationModal}
        handleCancel={() => setShowTranslationModal(false)}
        renderOk={true}
        okText={"Continue"}
        cancelText={"Keep Editing"}
        handleOk={handleResumeWizardFlow}
        primaryAction="submit"
      /> : null}
    {contextHolder}
    </>
  );
};
const mapStateToProps = function (store) {
  return {
    currentUser: store.accountState.getIn(['userDetails', 'value']) ?? {},
    sites: store.siteState.getIn(['sites', 'value'])?.filter((s) => s.type !== 'property_group' && s.domain && !s.domain.includes('-group-')),
    siteGroups: store.siteState
      .getIn(['siteGroups', 'value'])
      .sort(
        (a, b) => moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()
      ),
    globalVendors: store.usPrivacyReducerState.getIn(['mspsSystemVendors', 'value']) ?? OrderedSet([]),
    pendingRequestsMap: Map({
      sites: store.siteState.getIn(['sites', 'pending']),
      siteGroups: store.siteState.getIn(['siteGroups', 'pending']),
      regulation: store.usPrivacyReducerState.getIn(['savePending'])
    }),
  };
};

export default connect(mapStateToProps, {
  getSiteGroups,
  getAllSites,
  getGlobalVendors
})(USPrivacyRegulationEdit);
